/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// 满赠活动，最好放后端不要放前端
/* (() => {
  // M12
  const GIFT_A_ID = 44624748871930;
  // TKP13
  const GIFT_B_ID = 44624739041530;

  const cartUrl = window.themeVariables.routes.cartUrl;
  const cartUrlAjax = `${cartUrl}.js`;
  const cartAddUrlAjax = `${window.themeVariables.routes.cartAddUrl}.js`;
  const cartChangeUrlAjax = `${window.themeVariables.routes.cartChangeUrl}.js`;

  async function fetchJSON(url, options = {}) {
    try {
      const res = await fetch(url, options);

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      return res.json();

    } catch (err) {
      console.error(`❌ [fetchJSON] Error fetching ${url}:`, err);
      return null;
    }
  }

  function getUrl(url) {
    return fetchJSON(url, {
      method: 'GET',
      cache: 'reload',
      credentials: "same-origin",
    })
  }

  function postUrl(url, data) {
    return fetchJSON(url, {
      credentials: "same-origin",
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  }

  // 获取购物车信息
  async function fetchCart() {
    console.log('fetchCart')
    const res = await getUrl(cartUrlAjax);
    if (res) {
      GiftManager.checkAndApplyGift(res);
    };
  }

  const GiftManager = {
    isLocked: false,
    lastTotal: null,

    async checkAndApplyGift(cart) {
      if (this.isLocked) return;
      this.isLocked = true;
      console.log({ total: cart.total_price, lastTotal: this.lastTotal })

      console.log('checkAndApplyGift', Date.now())

      try {
        // Note： main-cart页面执行的是页面刷新每次刷新后this.lastTotal都是undefined,除非改成局部刷新
        // if (cart.total_price === this.lastTotal) {
        //   return; // 状态没变，跳过
        // }
        // this.lastTotal = cart.total_price;
        // 满赠逻辑
        const cartTotal = cart.total_price / 100; // 转换为元
        const giftAItem = cart.items.find(item => item.variant_id === GIFT_A_ID);
        const giftBItem = cart.items.find(item => item.variant_id === GIFT_B_ID);

        // 修正赠品数量（限制每种赠品最多只能 1 个）
        if (giftAItem && giftAItem.quantity > 1) {
          await updateGiftQuantity(giftAItem.key, 1);
        }
        if (giftBItem && giftBItem.quantity > 1) {
          await updateGiftQuantity(giftBItem.key, 1);
        }

        // 满 499 元送 A，满 699 元送 B
        if (cartTotal >= 699) {
          if (giftAItem) await removeGift(giftAItem.key);
          if (!giftBItem) await addGift(GIFT_B_ID);
        } else if (cartTotal >= 499) {
          if (giftBItem) await removeGift(giftBItem.key);
          if (!giftAItem) await addGift(GIFT_A_ID);
        } else {
          if (giftAItem) {
            await removeGift(giftAItem.key);
          }
          if (giftBItem) {
            await removeGift(giftBItem.key);
          }
        }

      } catch (err) {
        console.error('❌ 满赠逻辑出错:', err);
      } finally {
        this.isLocked = false;
      }

    }
  };

  // 检查并应用赠品
  async function checkAndApplyGift(cart) {
    const cartTotal = cart.total_price / 100; // 转换为元
    const giftAItem = cart.items.find(item => item.variant_id === GIFT_A_ID);
    const giftBItem = cart.items.find(item => item.variant_id === GIFT_B_ID);

    console.log({ cart })

    // 修正赠品数量（限制每种赠品最多只能 1 个）
    if (giftAItem && giftAItem.quantity > 1) {
      updateGiftQuantity(giftAItem.key, 1);
    }
    if (giftBItem && giftBItem.quantity > 1) {
      updateGiftQuantity(giftBItem.key, 1);
    }

    // 满 499 元送 A，满 699 元送 B
    if (cartTotal >= 699) {
      if (giftAItem) await removeGift(giftAItem.key);
      if (!giftBItem) await addGift(GIFT_B_ID);
    } else if (cartTotal >= 499) {
      if (giftBItem) await removeGift(giftBItem.key);
      if (!giftAItem) await addGift(GIFT_A_ID);
    } else {
      if (giftAItem) {
        await removeGift(giftAItem.key);
      }
      if (giftBItem) {
        await removeGift(giftBItem.key);
      }
    }
  }

  // 添加赠品
  async function addGift(variantId) {
    console.log('addGift')
    const res = await postUrl(cartAddUrlAjax, {
      id: variantId,
      quantity: 1,
    });
    if (res && res.id) {
      const res = await getUrl(cartUrlAjax);
      if (res) updateCartUI(res);
    }
  }

  async function updateGiftQuantity(variantId, qty) {
    console.log('updateGiftQuantity')
    const res = await postUrl(cartChangeUrlAjax, {
      id: `${variantId}`,
      quantity: qty
    });
    if (res) updateCartUI(res);
  }

  // 移除赠品
  async function removeGift(variantId) {
    console.log('removeGift');
    const res = await postUrl(cartChangeUrlAjax, {
      id: `${variantId}`,
      quantity: 0
    });
    if (res) updateCartUI(res);
  }

  // 更新购物车界面
  function updateCartUI(cart) {
    console.log('updateCartUI');
    if (window.location.pathname === cartUrlAjax || document.querySelector('.cart')) {
      console.log('updatUrl')
      // cart页面手动刷新
      fetch(cartUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newCartItems = doc.querySelector('#main-cart');
          document.querySelector('#main-cart').innerHTML = newCartItems.innerHTML;
        });
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: cart,
        }
      }));
    }
  }

  // 监听页面加载完成
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart(); // 页面加载时获取并检查购物车
  });

  document.addEventListener('cart:updated', async function (event) {
    console.log('cart:updated', Date.now());
    const detail = event.detail;
    if (detail && detail.cart) {
      GiftManager.checkAndApplyGift(detail.cart);
    }
  });


  // document.addEventListener('line-item-quantity:change:end', async function (event) {
  //   console.log('line-item-quantity:change:end');
  //   const cart = event.detail.cart;
  //   GiftManager.checkAndApplyGift(cart);
  // })

})() */

// video-list
// 参考product-list,有个限制css媒体查询不能灵活调整,只能为1000px
var VideoList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".video-list__scroller");
    this.videoItemList = this.querySelector(".video-list__item-list");
  }
  connectedCallback() {
    this.items = this.querySelectorAll("video-item");
    var isVideoPlayer = this.hasAttribute('is-video-player');
    if (isVideoPlayer) {
      this.localVideo = this.querySelector(".local-video");
      this.externalVideo = this.querySelector(".external-video");

      this.items.forEach((item, index) => {
        const aElement = item.querySelector('a');
        if (aElement) {
          const videoUrl  = aElement.getAttribute('data-video') || aElement.getAttribute('data-video-url');
          const videoType = aElement.getAttribute("data-video-type");
          if (index === 0) {
            this._switchVideoPlayer(videoUrl, videoType, true);
          }
          item.addEventListener("click", () => {
            this._switchVideoPlayer(videoUrl, videoType);
          });
        }
        this._handleItem(item, false)
      });
      // 绑定搜索过滤
      this.delegate.on("click", '.custom-input-addon', () => {
        const searchEle = this.querySelector('.custom-input');
        this._searchVideoFront(searchEle.value);
      });
      this.delegate.on("keydown", '.custom-input', (event) => {
        if (event.key === 'Enter') {
          this._searchVideoFront(event.target.value);
        }
      });
    } else {
      if (this.hasAttribute("scrollable")) {
        this.addEventListener("prev-next:prev", this.previous.bind(this));
        this.addEventListener("prev-next:next", this.next.bind(this));
        this.addEventListener("shopify:block:select", (event) => event.target.scrollIntoView({ block: "nearest", inline: "center", behavior: event.detail.load ? "auto" : "smooth" }));
      }
    }

    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    } else if (!isVideoPlayer) {
      this.items.forEach(item =>  this._handleItem(item, false))
    }
  }

  _escapeRegExp(str) {
    return str
      .toLowerCase()
      .replace(/[.*+?^=!:${}()|\[\]\/\\]/g, '\\$&')
      .replace(/\s+/g, ' ')
      .trim(); // 转义所有正则表达式特殊字符
  }

  // 纯前端视频搜索
  _searchVideoFront(value) {
    const input = this._escapeRegExp(value);
    const self = this;
    this.items.forEach(function (item) {
      const titleEle = item.querySelector('.video-description');
      if (titleEle) {
          const title = self._escapeRegExp(titleEle.textContent);

        const isMatch = title.includes(input);

        const isItemHide = item.classList.contains('forced-to-hide');

        if (isMatch && isItemHide) {
          item.classList.remove('forced-to-hide');
        } else if (!isMatch && !isItemHide) {
          item.classList.add('forced-to-hide');
        }
      }

    });
  }

    // 检查浏览器是否支持指定的视频类型
  _isVideoTypeSupported(mimeType) {
    return this.localVideo.canPlayType(mimeType) !== "";
  }

  // 封装一个函数来动态设置视频源
  _setVideoSource(url, isInit) {
    const video = JSON.parse(url);
    // 创建一个 DocumentFragment，它不会立即被渲染到页面中
    const fragment = document.createDocumentFragment();
    if (video.sources.length > 0) {
      video.sources.forEach(item => {
        const source = document.createElement('source'); // 创建 <li> 元素
        source.src =  item.url;
        source.type = item.mime_type;            // 设置列表项文本
        fragment.appendChild(source);                // 将 <li> 添加到 fragment
      });
      this.localVideo.innerHTML = '';
      if (isInit) {
          this.localVideo.removeAttribute('autoplay')
      } else {
        this.localVideo.setAttribute("autoplay", true)
      }

      this.localVideo.appendChild(fragment);
      this.localVideo.load();  // 重新加载视频
      this.localVideo.style.display = "block";
    } else {
      this.localVideo.style.display = "none"; // 隐藏本地视频播放器
      console.error('Unsupported video');
    }
  }

  // 设置外部视频 (YouTube/Vimeo) 的 iframe 来源
  _setIframeSource(url, type, isInit) {
    if (type === "youtube") {
      this.externalVideo.src = `https://www.youtube.com/embed/${url.split('v=')[1]}?playsinline=1&autoplay=${isInit ? 0 : 1}&modestbranding=1&rel=0&origin=${encodeURI(`https://${window.themeVariables.routes.host}`)}`;
    } else if (type === "vimeo") {
      this.externalVideo.src = `https://player.vimeo.com/video/${url.split('/').pop()}?autoplay=1&autopause=1&transparent=0&responsive=1`;
    }
  }

  // 切换视频播放器（本地或外部视频）
  _switchVideoPlayer(url, type, isInit = false) {
    if (type === "youtube" || type === "vimeo") {
      this.localVideo.setAttribute("hidden", true);
      this.externalVideo.removeAttribute("hidden");
      this._setIframeSource(url, type, isInit);
    } else {
      this.localVideo.removeAttribute("hidden");
      this.externalVideo.setAttribute("hidden", true)
      this._setVideoSource(url, isInit);
    }
  }

  _toggleSkeleton(aWrapper, skeletonEle) {
    if (aWrapper) aWrapper.classList.remove('hide-video-item');;
    if (skeletonEle) skeletonEle.style.display = 'none';
  }

  _handleItem(item, animation = false) {
    const aWrapper = item.querySelector('.video-list__item');
    const skeletonEle = item.querySelector('.skeleton-wrapper');
    const img = item.querySelector('.video-list__item-image');
    // TODO: 找更好的属性进行判断
    if (item.hasAttribute('cover_image')) {
      this._toggleSkeleton(aWrapper, skeletonEle);
      return;
    }

    if (img && img.tagName === 'IMG') {

      const handleImageLoad = () => {
        this._toggleSkeleton(aWrapper, skeletonEle);
        if (animation) animation.play();

        // 移除 onload 事件监听器，防止多次调用
        img.removeEventListener('load', handleImageLoad);
        img.removeEventListener('error', handleImageLoad);
      };

      const handleImageError = () => {
        this._toggleSkeleton(aWrapper, skeletonEle);
        aWrapper.classList.add('error-image-wrapper');

        // 移除 onerror 事件监听器
        img.removeEventListener('load', handleImageLoad);
        img.removeEventListener('error', handleImageLoad);
      };

      // 如果图片已经加载完成，直接调用 onload 处理逻辑
      if (img.complete && img.src && !img.src.startsWith('data:image/')) {
        handleImageLoad();  // 手动调用处理逻辑，而不是触发 onload 事件
        return;
      }

      img.addEventListener('load', handleImageLoad);
      img.addEventListener('error', handleImageError);

      const srcset = img.getAttribute('data-srcset');
      const src = img.getAttribute('data-src');

      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-srcset');
      }
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
      }
    }
  }

  async _setupVisibility() {
    const prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    // 使用 IntersectionObserver 进行懒加载
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const item = entry.target; // 当前进入视口的 item
          const img = item.querySelector('.video-list__item-image');
          const textItem = item.querySelector('.video-description');

          // 图片进入视口后，添加动画
          const animation = new CustomAnimation(new ParallelEffect([
            new CustomKeyframeEffect(img, {
              opacity: [0, 1],
              transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"]
            }, {
              duration: 250,
              easing: "cubic-bezier(0.65, 0, 0.35, 1)"
            }),
            new CustomKeyframeEffect(textItem, {
              opacity: [0, 1],
              clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"],
              transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"]
            }, {
              duration: 200,
              easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
            })
          ]));

          this._handleItem(item, animation);

          // 停止观察当前元素
          observer.unobserve(item);
        }
      });
    }, { threshold: 0.1 });


    // 处理图片加载过程
    this.items.forEach((item) => {
      // 开始观察该 item
      observer.observe(item);
    });
  }
  previous(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this.videoItemList).getPropertyValue("grid-gap"));
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.productListInner.scrollLeft * directionFlip - (this.productListInner.clientWidth + columnGap) <= 0);
    this.productListInner.scrollBy({ left: -(this.productListInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
  }
  next(event) {
    const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this.videoItemList).getPropertyValue("grid-gap"));
    console.log({ directionFlip, columnGap })
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute("disabled", this.productListInner.scrollLeft * directionFlip + (this.productListInner.clientWidth + columnGap) * 2 >= this.productListInner.scrollWidth);
    this.productListInner.scrollBy({ left: (this.productListInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
  }

}
window.customElements.define("video-list", VideoList);


// 灯箱
var WeightLengthPswp =  class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback();
    LibraryLoader.load("photoswipe");

    this.querySelector('a').addEventListener('click', this.openPhotoSwipe);
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    (_a = this.photoSwipeInstance) == null ? void 0 : _a.destroy();
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    switch (name) {
      case "open":
        if (this.open) {
          await LibraryLoader.load("photoswipe");
          this._openPhotoSwipe();
        }
    }
  }
  async openPhotoSwipe(event){
    event.preventDefault();
    await LibraryLoader.load("photoswipe");
      const pswpElement = document.querySelectorAll('.pswp')[0];

      // b. 准备图片数据
      const items = [
        {
          // 原始大图 URL，作为后备
          src: this.getAttribute('data-src'),
          // 原始宽高
          w: parseInt(this.getAttribute('data-width'), 10),
          h: parseInt(this.getAttribute('data-height'), 10),
          srcset: this.getAttribute('data-pswp-srcset'),
          sizes: this.getAttribute('data-pswp-sizes')
        }
      ];

      // c. 准备选项
      const options = {
          index: 0,
          shareEl: false,
          counterEl: false
      };

      // d. 初始化并打开 PhotoSwipe
      // 此时 window.PhotoSwipe 和 window.PhotoSwipeUI_Default 肯定存在
      const gallery = new window.ThemePhotoSwipe(pswpElement, PhotoSwipeUi, items, options);
      gallery.init();
  }
}
window.customElements.define("weight-length-pswp", WeightLengthPswp);